export default __webpack_public_path__ + "static/media/alertBlue.47c82bee.svg";